import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const ColorButton = styled(Button)(({ theme }) => ({
  color: '#2FAB73',
  backgroundColor: 'rgba(47, 171, 115, 0.3)',
  border: '0.4px solid #2FAB73',
  borderRadius: '3px',
}));

export const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});
